/** Signup is app-only — the web console has no account forms. */
import { Navigate } from 'react-router-dom';

export function SignupPage(): JSX.Element {
  return <Navigate to="/login" replace />;
}
